// src/components/SEOHelmet.js
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SEO_CONFIG } from '../config/seo';

const SEOHelmet = ({ 
  title = "Andy Osburn - Tulsa Real Estate Broker, Agent & Property Manager | 34+ Years",
  description = "Find your dream home in Tulsa Metro with Andy Osburn, licensed real estate broker, agent, and property manager. 34+ years experience in residential, commercial, land development, and asset management. Serving Tulsa, Broken Arrow, Bixby, Jenks, Owasso, and Sapulpa.",
  keywords = "Andy Osburn, Tulsa real estate broker, Tulsa real estate agent, Oklahoma property manager, Broken Arrow homes, Bixby properties, Jenks real estate, Owasso homes, Sapulpa properties, Oklahoma real estate, MLS 110594, TRESCO LLC, Fox + Associates, Tulsa realtor, commercial real estate Tulsa, property management",
  canonical = "https://trescollc.com",
  ogImage = "https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/headshots/a.osburn.tulsa_83f6d352fdda4d9b8cb1615a19b9d607.jpg"
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />
      
      {/* Conversational/Chat Keywords */}
      <meta name="chat-keywords" content="ask real estate questions, property chat, home buying help, real estate assistant, talk to agent, property advice" />
      
      {/* Local SEO */}
      <meta name="geo.region" content={SEO_CONFIG.COUNTRY} />
      <meta name="geo.placename" content={`${SEO_CONFIG.CITY}, ${SEO_CONFIG.STATE}`} />
      <meta name="geo.position" content={`${SEO_CONFIG.LATITUDE};${SEO_CONFIG.LONGITUDE}`} />
      <meta name="ICBM" content={`${SEO_CONFIG.LATITUDE}, ${SEO_CONFIG.LONGITUDE}`} />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={canonical} />
      
      {/* Twitter */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Structured Data for Real Estate Agent */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "RealEstateAgent",
          "name": SEO_CONFIG.AGENT_NAME,
          "telephone": SEO_CONFIG.AGENT_PHONE,
          "email": SEO_CONFIG.AGENT_EMAIL,
          "url": SEO_CONFIG.DOMAIN,
          "address": {
            "@type": "PostalAddress",
            "streetAddress": SEO_CONFIG.STREET_ADDRESS,
            "addressLocality": SEO_CONFIG.CITY,
            "addressRegion": SEO_CONFIG.STATE,
            "postalCode": SEO_CONFIG.ZIP_CODE,
            "addressCountry": SEO_CONFIG.COUNTRY
          }
        })}
      </script>
    </Helmet>
  );
};

export default SEOHelmet;